/** Extract a human-readable message from LK / cabinet JSON error bodies. */
export function extractErrorDetail(body: unknown, fallback: string): string {
  if (!body || typeof body !== 'object') return fallback;
  const o = body as Record<string, unknown>;
  if (typeof o.message === 'string' && o.message.trim()) return o.message.trim();
  const err = o.error;
  if (typeof err === 'string' && err.trim()) return err.trim();
  if (err && typeof err === 'object') {
    const nested = err as Record<string, unknown>;
    if (typeof nested.message === 'string' && nested.message.trim()) return nested.message.trim();
    if (typeof nested.code === 'string' && nested.code.trim()) return nested.code.trim();
  }
  return fallback;
}

export async function readHttpErrorDetail(res: Response, fallback?: string): Promise<string> {
  const fb = fallback ?? `HTTP ${res.status}`;
  const ct = res.headers.get('Content-Type') ?? '';
  try {
    if (ct.includes('application/json')) {
      const body = await res.json();
      return extractErrorDetail(body, fb);
    }
    const text = (await res.text()).trim();
    return text.slice(0, 500) || fb;
  } catch {
    return fb;
  }
}
